import styles from './styles/Items.icons.module.scss';
import React from 'react';
import { useAlgoliaDataContext } from '../../hooks/useAlgoliaDataContext';
import { useFacetLogic } from '../../hooks/useFacetLogic';
import { defaultSearchParams } from '../../configs';
import { Ssvg } from '../../../Components/react/Ssvg';
import { getLayoutIcon } from '../../../js/helpers/getLayoutIcon';
import { FACET_KEY_PIECES } from '../../constants/facetKeys';
export const ItemsIcons = ({ fConfig }) => {
    const { facets } = useAlgoliaDataContext();
    const [activeValues, itemClickHandler] = useFacetLogic(fConfig.key, fConfig.singleSelect);
    return (React.createElement("ul", { "data-cy-test": 'CollectionFilter-Icons', className: `list:none d:grid ${styles.items}` }, facets[fConfig.key].map(({ value, label, count }) => {
        const isActiveAsDefault = defaultSearchParams.facets[fConfig.key]?.includes(value);
        const isActive = isActiveAsDefault || activeValues.includes(value);
        const isDisabled = count === 0;
        const itemStateClass = isDisabled
            ? `pev:none ${styles.itemDisabled}`
            : isActive
                ? `bxsh:2 ${styles.itemActive}`
                : '';
        const title = fConfig.key === FACET_KEY_PIECES
            ? `${label} Piece${label !== '1' ? 's' : ''}`
            : label;
        return (React.createElement("li", { "data-cy-test": `${isDisabled ? 'CollectionFilterItem-Disabled' : 'CollectionFilterItem'}`, key: value },
            React.createElement("button", { className: `btn:cleared w:100p bdrs:1 text:center text:uppercase d:flex fd:column ai:center jc:center trs:all:300 ov:h ${styles.item} ${itemStateClass}`, onClick: () => { !isActiveAsDefault && itemClickHandler(value); } },
                React.createElement(Ssvg, { icon: getLayoutIcon(value), className: `d:block ${styles.itemIcon}` }),
                React.createElement("span", { className: `d:flex ai:center ${styles.itemTitle}` }, title))));
    })));
};
